import type { Document } from "./document";
import type { DocumentGroup } from "./document-group";

export function getPrevNextDocument(documents: DocumentGroup[], slug: string) {
	const groups = documents;
	const flat: { title: string; path: string }[] = [];

	for (const group of groups) {
		for (const document of group.documents) {
			flat.push({
				title: document.title,
				path: `/${document.slug.join("/")}`,
			});
		}
	}

	if (slug.length > 1 && slug.endsWith("/")) {
		slug = slug.slice(0, -1);
	}
	const index = flat.findIndex((p) => p.path === slug);

	return {
		prev: index > 0 ? flat[index - 1] : null,
		next: index < flat.length - 1 ? flat[index + 1] : null,
	};
}

export function slugComparator(p: Document, slug: string) {
	// pokud slug končí znakem /, tak ho odstranit
	if (slug.endsWith("/")) {
		slug = slug.slice(0, -1);
	}

	if (slug == "") slug = "/";

	if (p.slug.length == 0 || p.slug[0] == "") {
		return slug == "/";
	}
	return "/" + p.slug.join("/") === slug;
}

export function getDocumentBySlug(documents: DocumentGroup[], slug: string) {
	const group = documents.find((g) => g.documents.some((p) => slugComparator(p, slug)));
	return group?.documents.find((p) => slugComparator(p, slug));
}
